import { Component, EventEmitter, Input, OnDestroy, Output, OnInit } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject, takeUntil } from 'rxjs';

@Component({
  template: ''
})
export class BaseSelectComponent<T, K> implements ControlValueAccessor, OnDestroy, OnInit {
  @Input() placeholder: string = 'SELECT_OPTION';
  @Input() limit: number = 100;

  @Output() onSelectedItem = new EventEmitter<T>();

  protected hasValue = false;
  protected listItems: { name: string; item: T }[] = [];
  protected isLoading = false;
  protected _destroy$ = new Subject<void>();
  protected isMobile = false;

  // Control Value Accessor methods
  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(protected breakpointObserver?: BreakpointObserver) {}

  ngOnInit(): void {
    // Verifica se siamo su dispositivo mobile
    if (this.breakpointObserver) {
      this.breakpointObserver
        .observe([Breakpoints.HandsetPortrait, Breakpoints.TabletPortrait])
        .pipe(takeUntil(this._destroy$))
        .subscribe(result => {
          this.isMobile = result.matches;
        });
    }
  }

  writeValue(obj: T): void {
    if (obj) {
      this.onSelectItem(obj);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Implementation for disabled state can be added here
  }

  onSelectItem(item: T): void {
    if (item) {
      this.hasValue = true;
      this.onChange(item);
      this.onSelectedItem.emit(item);
    }
  }

  onClearItem(): void {
    this.hasValue = false;
    this.onChange(null);
    this.onSelectedItem.emit(null as any);
  }

  protected getItems(query: string): void {
    this.isLoading = true;
    // To be overridden by child components
  }

  // Metodo per gestire la selezione dal select nativo
  onNativeSelectChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const selectedIndex = selectElement.selectedIndex;
    
    if (selectedIndex === 0) {
      // Placeholder selezionato
      this.onClearItem();
    } else if (selectedIndex > 0 && this.listItems.length >= selectedIndex) {
      // Opzione valida selezionata (compensiamo -1 per il placeholder)
      const selectedItem = this.listItems[selectedIndex - 1];
      if (selectedItem && selectedItem.item) {
        this.onSelectItem(selectedItem.item);
      }
    }
  }

  onNativeSelectFocus(): void {
    const isListEmpty = !this.listItems || this.listItems.length === 0;
    if (isListEmpty && !this.isLoading) {
      this.getItems('');
    }
  }

  onDropdownShow(): void {
    const isListEffectivelyEmptyOrJustPlaceholder = 
      this.listItems.length <= 1 && 
      (!this.listItems.length || 
       (this.hasValue && this.listItems.length === 1));
    
    if (isListEffectivelyEmptyOrJustPlaceholder && !this.isLoading) {
      this.getItems('');
    }
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
} 